import { useMutation, useQuery } from '@apollo/client'
import { ErrorComponent, ProgressSpinner } from '@medical/components'
import MyCarCommutingApplicationForm from '@medical/components/Forms/MyCarCommutingApplicationForm'
import { useCustom } from '@medical/provider/context'
import React from 'react'
import {
  GET_MY_CAR_COMMUTING_APPLICATION,
  CREATE_MY_CAR_COMMUTING_APPLICATION,
} from './DoctorMyCarCommutingApplication.graphql'
import moment from 'moment'

const DoctorMyCarCommutingApplication = ({ closeModal }) => {
  const [{ i18n, popup }] = useCustom()
  const { loading, error, data } = useQuery(GET_MY_CAR_COMMUTING_APPLICATION)

  const [createMyCarCommutingApplication] = useMutation(
    CREATE_MY_CAR_COMMUTING_APPLICATION
  )

  if (loading) return <ProgressSpinner />
  if (error) return <ErrorComponent error={error} />

  const onSubmit = async (values, { setSubmitting, setFieldValue }) => {
    try {
      const {
        frontSideLicenseKey,
        backSideLicenseKey,
        expirationDate,
        carCommuteStartDate,
        vehicleInspectionCertificateKey,
        liabilityInsuranceCertificateKey,
        vehicleInspectionExpirationDate,
        vehicleType,
        licensePlateNumberPart1,
        licensePlateNumberPart2,
        licensePlateNumberPart3,
        licensePlateNumberPart4,
        isAgreedToRegulations,
        voluntaryInsuranceCertificateKey,
        liabilityInsuranceCertificateExpirationDate,
        voluntaryInsuranceCertificateExpirationDate
      } = values

      await createMyCarCommutingApplication({
        variables: {
          frontSideLicenseKey,
          backSideLicenseKey,
          expirationDate: moment(expirationDate).format('YYYY-MM-DD'),
          carCommuteStartDate: moment(carCommuteStartDate).format('YYYY-MM-DD'),
          vehicleInspectionCertificateKey,
          liabilityInsuranceCertificateKey,
          vehicleInspectionExpirationDate: moment(vehicleInspectionExpirationDate).format('YYYY-MM-DD'),
          voluntaryInsuranceCertificateExpirationDate: moment(voluntaryInsuranceCertificateExpirationDate).format('YYYY-MM-DD'),
          liabilityInsuranceCertificateExpirationDate: moment(liabilityInsuranceCertificateExpirationDate).format('YYYY-MM-DD'),
          vehicleType,
          licensePlateNumberPart1,
          licensePlateNumberPart2,
          licensePlateNumberPart3,
          licensePlateNumberPart4,
          isAgreedToRegulations,
          voluntaryInsuranceCertificateKey
        },
      })

      popup.success(
        i18n.t('doctor.myCarCommutingApplication.submissionSuccess')
      )
      setSubmitting(false)
      closeModal()
    } catch (error) {
      popup.error(error)
      setFieldValue('confirm', false)
      setSubmitting(false)
    }
  }

  const myCarApp =
    data.doctorMe.myCarCommutingApplication &&
    data.doctorMe.myCarCommutingApplication.length > 0
      ? data.doctorMe.myCarCommutingApplication[0]
      : null

  const initialValues = myCarApp
    ? {
        ...myCarApp,
        expirationDate: myCarApp.expirationDate
          ? new Date(myCarApp.expirationDate)
          : null,
        carCommuteStartDate: myCarApp.carCommuteStartDate
          ? new Date(myCarApp.carCommuteStartDate)
          : null,
        vehicleInspectionExpirationDate: myCarApp.vehicleInspectionExpirationDate
          ? new Date(myCarApp.vehicleInspectionExpirationDate)
          : null,
        liabilityInsuranceCertificateExpirationDate: myCarApp.liabilityInsuranceCertificateExpirationDate
            ? new Date(myCarApp.liabilityInsuranceCertificateExpirationDate)
            : null,
        voluntaryInsuranceCertificateExpirationDate: myCarApp.voluntaryInsuranceCertificateExpirationDate
            ? new Date(myCarApp.voluntaryInsuranceCertificateExpirationDate)
            : null,
        confirm: false,
        staffComment: myCarApp?.staffComment ?? '',
      }
    : {
        frontSideLicenseKey: '',
        backSideLicenseKey: '',
        expirationDate: null,
        vehicleInspectionCertificateKey: '',
        liabilityInsuranceCertificateKey: '',
        voluntaryInsuranceCertificateKey: '',
        vehicleInspectionExpirationDate: null,
        vehicleType: '',
        licensePlateNumberPart1: '',
        licensePlateNumberPart2: '',
        licensePlateNumberPart3: '',
        licensePlateNumberPart4: '',
        isAgreedToRegulations: false,
        confirm: false,
        staffComment: '',
        carCommuteStartDate: null,
        voluntaryInsuranceCertificateExpirationDate: null,
        liabilityInsuranceCertificateExpirationDate: null,
      }

  const isDisabled =
    myCarApp && myCarApp.approvalStatus === 'WAITING_FOR_APPROVAL'

  return (
    <React.Fragment>
      <div className='modal-title p-autocomplete-query'>
        {i18n.t('doctor.myCarCommutingApplication.title')}
      </div>
      <MyCarCommutingApplicationForm
        closeModal={closeModal}
        initialValues={initialValues}
        onSubmit={onSubmit}
        confirmationMessage={i18n.t(
          'doctor.myCarCommutingApplication.confirmMessage'
        )}
        disabled={isDisabled}
      />
    </React.Fragment>
  )
}

export default DoctorMyCarCommutingApplication
